"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var google_1 = require("@react-oauth/google");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var appConfig_1 = __importDefault(require("../../../config/appConfig"));
var socialAuthApi_1 = __importDefault(require("../../../api/socialAuthApi"));
var SocialLoginPanel_module_scss_1 = __importDefault(require("./SocialLoginPanel.module.scss"));
var GoogleOAuthActionButton = function (_a) {
    var onAuthenticated = _a.onAuthenticated, onError = _a.onError, onLoadingChange = _a.onLoadingChange;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = (0, react_1.useState)(false), isSubmitting = _b[0], setIsSubmitting = _b[1];
    var setLoading = function (loading) {
        setIsSubmitting(loading);
        if (onLoadingChange) {
            onLoadingChange(loading);
        }
    };
    var fetchGoogleUser = function (accessToken) { return __awaiter(void 0, void 0, void 0, function () {
        var response, payload;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
                        headers: {
                            Authorization: "Bearer ".concat(accessToken)
                        }
                    })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error(t("GOOGLE_AUTH_ERROR_VERIFY_FAILED"));
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    payload = _a.sent();
                    return [2 /*return*/, {
                            sub: String((payload === null || payload === void 0 ? void 0 : payload.sub) || "google-user"),
                            email: String((payload === null || payload === void 0 ? void 0 : payload.email) || ""),
                            name: String((payload === null || payload === void 0 ? void 0 : payload.name) || (payload === null || payload === void 0 ? void 0 : payload.given_name) || "Google User"),
                            picture: String((payload === null || payload === void 0 ? void 0 : payload.picture) || "")
                        }];
            }
        });
    }); };
    var handleSuccess = function (tokenResponse) { return __awaiter(void 0, void 0, void 0, function () {
        var accessToken, verifiedLogin, user, error_1, message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    accessToken = tokenResponse.access_token;
                    if (!accessToken) {
                        onError(t("GOOGLE_AUTH_ERROR_NO_ID_TOKEN"));
                        return [2 /*return*/];
                    }
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, socialAuthApi_1.default.startGoogleOAuthLogin({
                            access_token: accessToken
                        })];
                case 2:
                    verifiedLogin = _a.sent();
                    return [4 /*yield*/, fetchGoogleUser(accessToken)];
                case 3:
                    user = _a.sent();
                    onAuthenticated({
                        user: user,
                        session_id: verifiedLogin.session_id,
                        access_token: verifiedLogin.access_token
                    });
                    return [3 /*break*/, 6];
                case 4:
                    error_1 = _a.sent();
                    message = error_1 instanceof Error
                        ? error_1.message
                        : t("GOOGLE_AUTH_ERROR_LOGIN_FAILED");
                    onError(message);
                    return [3 /*break*/, 6];
                case 5:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var startGoogleLogin = (0, google_1.useGoogleLogin)({
        scope: "openid email profile",
        onSuccess: handleSuccess,
        onError: function () { return onError(t("GOOGLE_AUTH_ERROR_POPUP_BLOCKED")); }
    });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("button", { type: "button", className: "".concat(SocialLoginPanel_module_scss_1.default.loginButton, " ").concat(SocialLoginPanel_module_scss_1.default.googleButton), onClick: function () { return startGoogleLogin(); }, disabled: isSubmitting, children: [(0, jsx_runtime_1.jsx)("span", { className: SocialLoginPanel_module_scss_1.default.googleIconBox, "aria-hidden": "true", children: (0, jsx_runtime_1.jsx)("span", { className: SocialLoginPanel_module_scss_1.default.googleGMark, children: "G" }) }), (0, jsx_runtime_1.jsx)("span", { className: SocialLoginPanel_module_scss_1.default.googleButtonLabel, children: t("GOOGLE_AUTH_BUTTON_LABEL") })] }), isSubmitting ? ((0, jsx_runtime_1.jsx)("p", { className: SocialLoginPanel_module_scss_1.default.googleHintText, children: t("GOOGLE_AUTH_HINT_VERIFYING") })) : null] }));
};
var GoogleAuthButton = function (_a) {
    var onAuthenticated = _a.onAuthenticated, onError = _a.onError, onLoadingChange = _a.onLoadingChange;
    var t = (0, react_i18next_1.useTranslation)().t;
    var googleClientID = (0, react_1.useMemo)(function () { return appConfig_1.default.getGoogleClientId(); }, []);
    if (!googleClientID) {
        return ((0, jsx_runtime_1.jsx)("div", { className: SocialLoginPanel_module_scss_1.default.googleLoginWrapper, children: (0, jsx_runtime_1.jsxs)("button", { type: "button", className: "".concat(SocialLoginPanel_module_scss_1.default.loginButton, " ").concat(SocialLoginPanel_module_scss_1.default.googleButton), disabled: true, title: t("GOOGLE_AUTH_TITLE_MISSING_CLIENT_ID"), children: [(0, jsx_runtime_1.jsx)("span", { className: SocialLoginPanel_module_scss_1.default.googleIconBox, "aria-hidden": "true", children: (0, jsx_runtime_1.jsx)("span", { className: SocialLoginPanel_module_scss_1.default.googleGMark, children: "G" }) }), (0, jsx_runtime_1.jsx)("span", { className: SocialLoginPanel_module_scss_1.default.googleButtonLabel, children: t("GOOGLE_AUTH_BUTTON_LABEL") })] }) }));
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: SocialLoginPanel_module_scss_1.default.googleLoginWrapper, children: (0, jsx_runtime_1.jsx)(google_1.GoogleOAuthProvider, { clientId: googleClientID, children: (0, jsx_runtime_1.jsx)(GoogleOAuthActionButton, { onAuthenticated: onAuthenticated, onError: onError, onLoadingChange: onLoadingChange }) }) }));
};
exports.default = GoogleAuthButton;
